export default __webpack_public_path__ + "static/media/annotation_hotspot.0d445c63.svg";